import { Types as TYPES } from '../types';
import { Endpoints as ENDPOINTS } from '../endpoints';

const actionType = TYPES.find(
    (type) => type.actionName === 'notificationAction'
);

const { baseUrl, routes } = ENDPOINTS;

const {
    NOTIFICATION_SEND_START,
    NOTIFICATION_SEND_SUCCESS,
    NOTIFICATION_SEND_FAILED,
    NOTIFICATION_SEND_STOP,
} = actionType.types;

export const sendRegistrationNotification = (params) => (dispatch) => {
    dispatch({
        type: NOTIFICATION_SEND_START,
    });

    const url = `${baseUrl}${routes.post.sendWelcome}`;

    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            first_name: params.first_name,
            email: params.email,
        }),
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error('Failed to send notification');
            }
            return response.json();
        })
        .then((data) => {
            dispatch({
                type: NOTIFICATION_SEND_SUCCESS,
                payload: data,
            });
        })
        .catch((error) => {
            console.log('notification error', error.message);
            dispatch({
                type: NOTIFICATION_SEND_FAILED,
                error: error.message,
            });
        })
        .finally(() => {
            dispatch({
                type: NOTIFICATION_SEND_STOP,
            });
        });
};
